import Select from "common/Select/Select";
import { SelectValue } from "antd/es/select";
import { CSSProperties, useEffect } from "react";
import TextWithIcon from "common/Text/TextWithIcon";
import { ICON_TYPES } from "@shared/common/constants";
import styled from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

interface ExchangeSelectionDropdownProps {
  setExchange: (exchange: string) => void;
  exchange?: string;
  exchanges?: string[];
  loading?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
}

const ExchangeSelectionDropdown = ({
  setExchange,
  exchange,
  exchanges,
  loading,
  disabled = false,
  style,
}: ExchangeSelectionDropdownProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);

  useEffect(() => {
    if (!exchange && exchanges?.length) {
      setExchange(exchanges[0]);
    } else if (
      exchange &&
      exchanges?.length &&
      !exchanges?.includes(exchange)
    ) {
      setExchange(exchanges[0]);
    }
  }, [exchanges, exchange, setExchange]);

  return (
    <StyledSelect
      disabled={disabled}
      style={{ minWidth: 110, ...style }}
      onChange={(exchange: SelectValue = "") =>
        setExchange(exchange.toString())
      }
      loading={loading}
      value={exchange}
      popupMatchSelectWidth={false}
      variant="borderless"
      options={exchanges?.map((exchange) => ({
        value: exchange,
        searchValue: exchange,
        label: (
          <TextWithIcon
            iconType={ICON_TYPES.EXCHANGE}
            coinOrExchangeName={exchange}
            text={exchange}
          />
        ),
      }))}
      showSearch={{ optionFilterProp: "searchValue" }}
      mobileTitle={t("assets.exchange")}
    />
  );
};

export default ExchangeSelectionDropdown;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    &:not(.ant-select-customize-input) {
      background: transparent;
    }
  }
`;
